module.exports = __webpack_public_path__ + "static/media/default.2bfe0242.svg";